import React from 'react';
import { Link } from 'react-router-dom';
import * as moment from "moment";
import { size, map } from "lodash";



const toLowerCase1 = str => {
    return (
        str === "" || str === undefined ? "" : str.toLowerCase()
    );
};

const Menu_Name = (cell) => {
    return cell.value ? cell.value : '';
};

const Sub_Name = (cell) => {
    return cell.value ? cell.value : '';
};

const Module_Code = (cell) => {
    return cell.value ? cell.value : '';
};

const Module_Name = (cell) => {
    return cell.value ? cell.value : '';
};

const Module_Description = (cell) => {
    return cell.value ? cell.value : '';
};

const Module_Route = (cell) => {
    return cell.value ? cell.value : '';
};


export {
    Menu_Name,
    Sub_Name,
    Module_Code,
    Module_Name,
    Module_Description,
    Module_Route,
};